export default __webpack_public_path__ + "static/media/psg2.9b00aab9.jpg";